module.exports = __webpack_public_path__ + "static/media/logo.df62a1e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 487
// module chunks = 0